import { Box, styled } from "@mui/material";

export const ChipsListDisplayContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});
